import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {ConfiguracaoEmail} from "../models/configuracao-email";
import {ComunicacaoService} from "../services/comunicacao.service";
import Swal from "sweetalert2";

@Component({
  selector: 'app-configuracao-email',
  standalone: false,
  templateUrl: './configuracao-email.component.html',
  styleUrl: './configuracao-email.component.css'
})
export class ConfiguracaoEmailComponent implements OnInit {
  loading = false;
  public colunas = ['ID', 'Email', 'Host', 'Ativo'];
  public linhas: any[] = [];
  novaConfiguracaoEmail = new ConfiguracaoEmail();

  showModalNovo = false;

  constructor(private toastr: ToastrService,
              private configuracaoService: ComunicacaoService) {}

  ngOnInit(): void {
    this.carregarConfiguracoes();
  }

  carregarConfiguracoes(): void {
    this.loading = true;
    this.linhas = [];
    this.configuracaoService.selecionarListaConfiguracoes().subscribe(resultado => {
      if(resultado.sucesso)
        this.preencherLista(resultado.dados);
      this.loading = false;
    });
  }

  preencherLista(configuracoes: ConfiguracaoEmail[]): void {
    for (let config of configuracoes) {
      let stringArray: string[] = [];
      let status = config.ativo ? 'Ativo' : 'Inativo';

      stringArray.push(
        config.id?.toString() || '0',
        config.email,
        config.host,
        status
      );

      this.linhas.push(stringArray);
    }
  }

  abrirModalNovo(): void {
    this.showModalNovo = true;
  }

  fecharModalNovo(): void {
    this.showModalNovo = false;
  }

  onBackgroundClick(event: Event): void {
    this.fecharModalNovo();
  }

  validar(): boolean{
    if(this.novaConfiguracaoEmail.email == null || this.novaConfiguracaoEmail.email == '') {
      this.toastr.error("O email não pode ser vazio");
      return false;
    }
    if(this.novaConfiguracaoEmail.host == null || this.novaConfiguracaoEmail.host == '') {
      this.toastr.error("O host não pode ser vazio");
      return false;
    }
    if(this.novaConfiguracaoEmail.senha == null || this.novaConfiguracaoEmail.senha == ''){
      this.toastr.error("A senha não pode ser vazia");
      return false;
    }

    return true;
  }

  salvarConfiguracao(): void {
    if(!this.validar())
      return;

    Swal.fire({
      title: 'Deseja realmente salvar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: 'var(--primary-color)',
      cancelButtonText: 'Cancelar'
    }).then((resultado) => {
      if(resultado.value){
        this.configuracaoService.adicionarConfiguracao(this.novaConfiguracaoEmail).subscribe(resultado => {
          if(resultado.sucesso){
            this.carregarConfiguracoes();
            this.fecharModalNovo();

            this.toastr.success("Configuração gravada com sucesso");
          }
          else{
            this.toastr.error(resultado.errors[0].mensagem);
          }
        });
      }
    }, error => {
      this.toastr.error("Erro ao adicionar configuração de email. Tente novamente mais tarde");
      if(error.error != null && error.error.errors[0].mensagem != null)
        this.toastr.error(error.error.errors[0].mensagem);
    });
  }

  desativarConfig(id: number): void {
    Swal.fire({
      title: 'Deseja realmente desativar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: 'var(--primary-color)',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if(result){
        this.configuracaoService.removerConfiguracao(id).subscribe(resultado => {
          if(resultado.sucesso){
            this.carregarConfiguracoes();
            this.toastr.success("Configuração de email removida com sucesso");
          }
          else{
            this.toastr.error(resultado.errors[0].mensagem);
          }
        });
      }
    });

  }

}
